let invalidate = () => {};
let queryState = () => undefined;

export function connectSchedulingCache(queryClient) {
  queryState = key => queryClient.getQueryState?.(key);
  const predicate = query => String(query.queryKey[0]).startsWith("scheduling-");
  invalidate = () => {
    // React Query v3 otherwise reuses an already-running request, which may
    // have read its snapshot before the mutation committed.
    // Cancellation updates query state synchronously in v3. Start invalidation
    // in the same turn, before navigation can mount another stale cached query.
    const cancelled = queryClient.cancelQueries({ predicate });
    const refreshed = queryClient.invalidateQueries({ predicate, refetchInactive: false });
    return Promise.all([cancelled, refreshed]);
  };
}

// Capture the preference once for this logical fetch, including all its pages.
// React Query clears isInvalidated after a successful fetch. A failed refresh
// retains it for that query's retry; unrelated queries continue using readers.
export function schedulingQuery(queryFn) {
  return context => queryFn({
    ...context,
    ...(queryState(context.queryKey)?.isInvalidated ? { consistency: "strong" } : {}),
  });
}

// A successful write remains successful even if a subsequent refresh fails.
export function schedulingDataChanged() {
  return Promise.resolve().then(invalidate).catch(() => {});
}
